// @ts-nocheck
import React, { Component } from "react"

import DataCard1xN from "./DataBlock1xN"
import DataCard2xN from "./DataBlock2xN"
import { getAge, getlinkedInSearchUrl, monthNameFromNumber /*, firstCharacterToUpperCase */ } from "../../modules/utilities"
import { BLOCK, COUNTRY, KIND, JARGON, LAYOUT, SEX, SEX_ENUM, TENSE, TENSE_ENUM, TOOLTIP } from "../../modules/constants"

import NumerableIconButton from "../NumerableIconButton"
import cheatSheetPdf_PersonBoardRoles from '../CheatSheetPdf_PersonBoardRoles'
import cheatSheetPdf_PersonCommittees from '../CheatSheetPdf_PersonCommittees'
import CompaniesHousePersonMenu from "./CompaniesHousePersonMenu"

import LinkedInBlack from "../img/linkedin-black.png"

import Box from "@mui/material/Box"
import MuiDivider from "@mui/material/Divider"
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined"

// Plain MUI Divider spans the full column width, but the column's left padding already
// insets its left end - so the right end also needs an explicit inset to match.
const Divider = () => <MuiDivider style={{ marginRight: LAYOUT.COLUMN_PADDING }} />

class PersonData extends Component {
  render() {
    // console.log("PersonData this.props: ", this.props)
    const { cheatSheet, csvEnabled, externalLinks, features, handleCsvButtonClick, hubData, kind, nodes, portrait, the350club } = this.props
    const { connectionCounts, dateOfBirth, linkedIn, name, sex } = hubData

    const concatNationalities = nationalities => nationalities.map(c => COUNTRY[c].nationality ?? JARGON.UNKNOWN).join(", ")
    const concatCountries = countries => countries.map(c => COUNTRY[c].country ?? JARGON.UNKNOWN).join(", ")

    const dataItems = {
      details: [
        { id: "age", value: dateOfBirth ? `${getAge(dateOfBirth)}` : JARGON.UNKNOWN },
        {
          id: "date of birth", value: dateOfBirth
            ? `${monthNameFromNumber(dateOfBirth.month)} ${dateOfBirth.year}`
            : JARGON.UNKNOWN
        },
        {
          id: "gender",
          value: externalLinks && (sex === SEX_ENUM.MALE || sex === SEX_ENUM.FEMALE)
            ? SEX[sex].NAME.toLowerCase()
            : JARGON.UNKNOWN,
          color: externalLinks && (sex === SEX_ENUM.MALE || sex === SEX_ENUM.FEMALE)
            ? SEX[sex].COLOR
            : SEX[SEX_ENUM.UNKNOWN].COLOR,
        },
        { id: JARGON.NATIONALITY.toLowerCase(), value: concatNationalities(hubData.nationalities) },
        { id: JARGON.RESIDENCE.toLowerCase(), value: concatCountries(hubData.countries) },
      ]
    }

    const appointments = connectionCounts?.appointments

    dataItems.appointmentCounts = appointments.officer.notice || appointments.officer.future
      ? [
        { id: `${TENSE[TENSE_ENUM.CURRENT].NAME.toLowerCase()}`, value: appointments.officer.current },
        { id: `${TENSE[TENSE_ENUM.NOTICE].NAME.toLowerCase()}`, value: appointments.officer.notice },
        { id: `${TENSE[TENSE_ENUM.PAST].NAME.toLowerCase()}`, value: appointments.officer.past },
        { id: `${TENSE[TENSE_ENUM.FUTURE].NAME.toLowerCase()}`, value: appointments.officer.future },
        {},
      ]
      : [
        { id: `${TENSE[TENSE_ENUM.CURRENT].NAME.toLowerCase()}`, value: appointments.officer.current },
        { id: `${TENSE[TENSE_ENUM.PAST].NAME.toLowerCase()}`, value: appointments.officer.past },
        {},
      ]

    var tipEnabled = TOOLTIP.exportAsCSV
    var tipDisabled = nodes.length <= 1
      ? ""
      : !csvEnabled && features?.Trial
        ? JARGON.NOT_INCLUDED_IN_TRIAL
        : JARGON.SUBSCRIBED_USERS_ONLY

    const csvButton = {
      disabled: !csvEnabled || nodes.length < 2, // 1st node is the person
      tipEnabled,
      tipDisabled: tipEnabled + tipDisabled,
      icon: <DescriptionOutlinedIcon />,
      label: "Export as CSV",
      handleClick: () => { handleCsvButtonClick() },
      fontWeight: "normal",
    }

    const pdfProps = {
      ...this.props,
      dataItems,
      cheatSheet,
    }

    tipEnabled = "generate a PDF snapshot of this person"

    const pdfButton = {
      disabled: !cheatSheet || nodes.length < 2, // 1st node is the person
      tipEnabled,
      tipDisabled: tipEnabled + tipDisabled,
      icon: <DescriptionOutlinedIcon />,
      label: `${JARGON.CHEAT_SHEET} PDF`,
      handleClick: (kind === KIND.NEXUS.PERSON.ROLES || kind === KIND.NEXUS.PERSON.CONNECTIONS)
        ? () => { cheatSheetPdf_PersonBoardRoles(pdfProps) }
        : () => { cheatSheetPdf_PersonCommittees(pdfProps) },
      fontWeight: "normal",
    }

    const label = linkedIn ? "LinkedIn Profile" : "LinkedIn search"
    tipEnabled = JARGON.EXTERNAL_LINK_TO + label

    const linkedInButton = {
      disabled: !externalLinks,
      tipEnabled,
      tipDisabled: tipEnabled + JARGON.SUBSCRIBED_USERS_ONLY,
      image: LinkedInBlack,
      label,
      handleClick: () => { window.open(linkedIn ? linkedIn : getlinkedInSearchUrl(name), "_blank") },
      fontWeight: "normal",
    }

    return (

      <React.Fragment>

        <
          // @ts-ignore
          DataCard1xN dataItems={dataItems.details} valueFontSize={BLOCK.FONT_SIZE} />
        <Divider />

        <
          // @ts-ignore
          DataCard2xN title={`UK ${JARGON.BOARD.toLowerCase()} ${JARGON.APPTS.toLowerCase()}`}
          dataItems={dataItems.appointmentCounts} valueFontSize={BLOCK.FONT_SIZE} />
        <Divider />

        {(kind === KIND.NEXUS.PERSON.ROLES || kind === KIND.NEXUS.PERSON.COMMITTEES || kind === KIND.NEXUS.PERSON.CONNECTIONS) &&
          <React.Fragment>
            <
              // @ts-ignore
              NumerableIconButton item={pdfButton} portrait={portrait} />
            <
              // @ts-ignore
              NumerableIconButton item={csvButton} portrait={portrait} />

            {!portrait && <Divider />}
          </React.Fragment>
        }

        <
          // @ts-ignore
          NumerableIconButton item={linkedInButton} portrait={portrait} />

        {/* Companies House links */}
        {
          hubData.chIds.length > 0 && !portrait && !the350club &&
          <CompaniesHousePersonMenu externalLinks={externalLinks} hubData={hubData} />
        }

        {portrait ? <Divider /> : <
          // @ts-ignore
          Box style={{ height: 40 }} />}

      </React.Fragment>
    )
  }
}

export default PersonData